import {Container} from "./Container"
import {Card} from "./Card"
import {Spinner} from "./Spinner"

export const LoadingModalStyles = {
    Container: Container,
    Card: Card,
    Spinner
}